<template>
  <div class="row">
    <div class="left">
      <div class="category-title">
        <div class="category-name">{{ category.name }}</div>
        <div class="count-count">
          （{{ checkedCount }}/{{ category.itemTagList.length }}）
        </div>
      </div>
      <el-checkbox
        v-if="isMultiSelect"
        :indeterminate="globalIndeterminate"
        :value="globalAllChecked"
        @change="checkGlobalAll"
      >
        全选
      </el-checkbox>
    </div>
    <div class="right">
      <div class="tag-header">
        <!-- 收起 -->
        <template v-if="!category.expand">
          <div ref="collapseBox" class="collapse-tags">
            <span
              v-for="item in category.itemTagList"
              :key="item.id"
              :class="['tag-item', { checked: item.checked }]"
              ref="tag"
              @click="toggleTag(item)"
            >
              {{ item.name }}
            </span>
          </div>
        </template>
        <!-- 展开 -->
        <template v-else>
          <div class="search">
            <el-input
              v-model="category.keyword"
              placeholder="多个关键词用空格分隔"
              size="mini"
              clearable
            >
              <i
                v-if="!category.keyword"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
            <template v-if="isMultiSelect">
              <el-checkbox class="mr15"
                :indeterminate="allIndeterminate"
                :value="allChecked"
                @change="checkAll"
              >
                全选（{{ searchChecked }}/{{ filterList.length }}）
              </el-checkbox>
              <el-checkbox v-model="reverse" @change="reverseCheck">
                反选
              </el-checkbox>
            </template>
            <bi-button class="ml20" type="blueText" @click="clearCategory">
              清空
            </bi-button>
          </div>
        </template>
        <div class="operate">
          <bi-button type="blueText" @click="toggle">
            <i class="el-icon-arrow-up" v-if="category.expand"></i>
            <i class="el-icon-arrow-down" v-else></i>
            {{ category.expand ? "收起" : "展开" }}
          </bi-button>
        </div>
      </div>
      <div class="tags" v-if="category.expand">
        <span
          v-for="item in filterList"
          :key="item.id"
          :class="['tag-item', { checked: item.checked }]"
          @click="toggleTag(item)"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    category: Object,
    isMultiSelect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      reverse: false,
    };
  },
  computed: {
    checkedCount() {
      return this.category.itemTagList.filter((i) => i.checked).length;
    },
    filterList() {
      const keyword = this.category.keyword.trim();
      if (!keyword) {
        return this.category.itemTagList;
      }
      const keywords = keyword.split(/\s+/);
      return this.category.itemTagList.filter((item) =>
        keywords.some((k) => item.name.includes(k)),
      );
    },
    searchChecked() {
      return this.filterList.filter((item) => item.checked).length;
    },
    // 搜索结果全部选中
    allChecked() {
      return (
        this.filterList.length && this.searchChecked === this.filterList.length
      );
    },
    // 搜索结果部分选中
    allIndeterminate() {
      return (
        this.searchChecked > 0 && this.searchChecked < this.filterList.length
      );
    },
    // 所有标签全部选中
    globalAllChecked() {
      return this.checkedCount === this.category.itemTagList.length;
    },
    // 所有标签部分选中
    globalIndeterminate() {
      return (
        this.checkedCount > 0 &&
        this.checkedCount < this.category.itemTagList.length
      );
    },
  },
  watch: {
    // 监听搜索
    "category.keyword"(val) {
      // 没有关键词不处理
      if (!val.trim()) {
        return;
      }
      if (this.isMultiSelect) {
        // 多选模式：搜索关键词时，先取消所有选中状态
        this.category.itemTagList.forEach((item) => {
          item.checked = false;
        });
        // 搜索结果默认全部选中
        this.$nextTick(() => {
          this.filterList.forEach((item) => {
            item.checked = true;
          });
        });
      }
      this.reverse = false;
    },
  },
  methods: {
    // 切换展开状态
    toggle() {
      this.category.expand = !this.category.expand;
    },
    // 点击标签
    toggleTag(item) {
      if (!this.isMultiSelect) {
        this.category.itemTagList.forEach((t) => {
          if (t.id !== item.id) t.checked = false;
        });
        item.checked = !item.checked;
        this.$emit("single-select", item);
      } else {
        item.checked = !item.checked;
      }
      this.reverse = false;
      this.$emit("change");
    },
    // 全选-搜索结果
    checkAll(val) {
      this.filterList.forEach((item) => {
        item.checked = val;
      });
      this.reverse = false;
    },
    // 反选-搜索结果
    reverseCheck() {
      this.filterList.forEach((item) => {
        item.checked = !item.checked;
      });
    },
    // 全选-所有标签
    checkGlobalAll(val) {
      this.category.itemTagList.forEach((item) => {
        item.checked = val;
      });
      this.reverse = false;
    },
    // 清空-所有标签
    clearCategory() {
      this.category.itemTagList.forEach((item) => {
        item.checked = false;
      });
      this.reverse = false;
      this.category.keyword = "";
    },
  },
};
</script>

<style scoped lang="scss">
.collapse-tags {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  overflow: hidden;
}
.tag-item {
  padding: 6px 8px;
  flex-shrink: 0;
  background: #f3f5f7;
  border: 1px solid #f3f5f7;
  color: #4c4c4c;
  border-radius: 4px;
  cursor: pointer;
  &.checked {
    box-sizing: border-box;
    background: #f4f6ff;
    border-radius: 4px;
    border: 1px solid #3159ff;
    color: #3159ff;
  }
}
.row {
  display: flex;
  border-bottom: 1px solid #eee;
  width: 100%;
}
.left {
  width: 164px;
  flex-shrink: 0; /* 防止左侧被挤压 */
  padding: 12px;
  background: #f3f5f7;
  box-sizing: border-box;
  // display: flex;
  font-size: 14px;
  color: #333;
  .category-title {
    display: flex;
  }
  .category-name {
    max-width: 96px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .count-count {
    flex-shrink: 0;
  }
}
.right {
  flex: 1;
  min-width: 0; /* 关键，允许flex缩小 */
  padding: 12px;
  overflow: hidden;
  box-sizing: border-box;
  .tag-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.operate {
  width: 80px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.search {
  display: flex;
  align-items: center;
}
.search .el-input {
  width: 250px;
  margin-right: 15px;
  :deep(.el-input__inner:focus) {
    background: #ffff;
    color: #333333;
    border-radius: 4px;
    border: 1px solid #3159ff !important;
  }
}
.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 315px;
  overflow: auto;
  margin-top: 10px;
}
.tags::-webkit-scrollbar {
  display: none;
}
.ml20 {
  margin-left: 20px;
}
.mr15 {
  margin-right: 15px;
}
</style>
